/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Blood glucose card
 */

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FrownFilled, SmileFilled } from '@ant-design/icons';
import { ReactComponent as Glucose } from '@nephro/assets/glucose-icon-white.svg';

// Helpers
import {
  BLOOD_GLUCOSE_INDICATOR,
  HIGH,
  STAGE_INDICATOR,
  PATIENT_CONDITIONS
} from 'pages/Indicators/helpers/constants';

// Hooks
import usePatientIndicators from 'pages/Indicators/helpers/usePatientIndicators';

import {
  getGlycosylatedHemoglobinLevel,
  getPatientStage
} from 'pages/Indicators/helpers/utils';
import DashboardPatientCard from '../dashboardPatientCard';

const footerIconStyle = { fontSize: 25, color: '#105742' };

const BloodGlucoseCard = () => {
  const { t: translate } = useTranslation();
  const [data, setData] = useState(null);
  const [stage] = usePatientIndicators(STAGE_INDICATOR);
  const [bloodGlucose] = usePatientIndicators(BLOOD_GLUCOSE_INDICATOR);
  const conditions = usePatientIndicators(PATIENT_CONDITIONS);

  const title = translate('dashboardPatient.bloodGlucoseTitle');

  const getFooterValue = () => {
    const stageValue = getPatientStage(stage.valor);
    const bloodGlucoseValue = bloodGlucose.valor;
    const bloodGlucoseLevel = getGlycosylatedHemoglobinLevel(
      bloodGlucoseValue,
      stageValue
    );
    return {
      text: `${bloodGlucoseValue}%`,
      icon:
        bloodGlucoseLevel === HIGH ? (
          <FrownFilled style={footerIconStyle} />
        ) : (
          <SmileFilled style={footerIconStyle} />
        )
    };
  };

  useEffect(() => {
    if (bloodGlucose && stage && conditions.length > 0) {
      const footer = getFooterValue();
      const [diabeticItem] = conditions?.filter((itm) => itm.parametro === 25);
      const componentData = {
        title,
        link: 'patient-blood-glucose',
        mainIcon: <Glucose />,
        footer,
        background: 'bg-cardCyan',
        textStyles: 'text-green-900',
        titleStyles: 'text-green-900'
      };
      setData(diabeticItem.valor_texto === 'SI' ? componentData : null);
    } else {
      setData(null);
    }
  }, [bloodGlucose, stage, title, conditions]);

  return <DashboardPatientCard data={data} />;
};

export default BloodGlucoseCard;
